module.exports = __webpack_public_path__ + "static/media/video_portada.b609ff65.mp4";